import { Identifiable, List } from "@planzone/dto";
import { Boundaries } from "@planzone/core";

function handleDuplicateList(
  list: Identifiable<List>,
  data: Boundaries["duplicateList"]["success"],
): Identifiable<List> {
  const { list: targetList, duplicatedList } = data;
  const isTargetList =
    (targetList.parentList && list.uuid === targetList.parentList.uuid) ||
    !!list.subLists.find(({ uuid }) => uuid === targetList.uuid);

  return isTargetList
    ? { ...list, subLists: [...list.subLists, duplicatedList] }
    : {
        ...list,
        subLists: list.subLists.map((subList) =>
          handleDuplicateList(subList, data),
        ),
      };
}

export { handleDuplicateList };
